import React, { createContext, useContext, useState, useEffect } from 'react';

// Mobile context for managing mobile-specific state
const MobileContext = createContext(null);

export const useMobile = () => {
  const context = useContext(MobileContext);
  if (!context) {
    throw new Error('useMobile must be used within MobileProvider');
  }
  return context;
};

export const MobileProvider = ({ children }) => {
  const [currentTask, setCurrentTask] = useState(null);
  const [scanHistory, setScanHistory] = useState([]);
  const [deviceInfo, setDeviceInfo] = useState(null);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [pendingScans, setPendingScans] = useState([]); // For offline support

  useEffect(() => {
    // Detect device info
    const ua = navigator.userAgent;
    setDeviceInfo({
      isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua),
      isAndroid: /Android/i.test(ua),
      isIOS: /iPhone|iPad|iPod/i.test(ua),
      userAgent: ua
    });

    // Online/offline detection
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  // Add scan to history
  const addScan = (scan) => {
    setScanHistory(prev => [{
      ...scan,
      timestamp: new Date().toISOString()
    }, ...prev].slice(0, 100)); // Keep last 100 scans
  };

  // Queue scan for offline sync
  const queuePendingScan = (scan) => {
    setPendingScans(prev => [...prev, {
      ...scan,
      queuedAt: new Date().toISOString()
    }]);
  };

  // Sync pending scans when online
  const syncPendingScans = async () => {
    if (!isOnline || pendingScans.length === 0) return;
    
    // Process pending scans
    const remaining = [];
    for (const scan of pendingScans) {
      try {
        // API call to sync scan
        // await api.syncScan(scan);
      } catch (error) {
        remaining.push(scan);
      }
    }
    setPendingScans(remaining);
  };

  return (
    <MobileContext.Provider value={{
      currentTask,
      setCurrentTask,
      scanHistory,
      addScan,
      deviceInfo,
      isOnline,
      pendingScans,
      queuePendingScan,
      syncPendingScans
    }}>
      {children}
    </MobileContext.Provider>
  );
};

export default MobileProvider;
